import {Component, OnInit, ViewChild} from '@angular/core';
import {PageTitleComponent} from '../../components/page-title/page-title.component';
import {SearchFormComponent} from '../../components/search-form/search-form.component';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {DateRangePickerComponent} from '../../components/date-range-picker/date-range-picker.component';
import {InputComponent} from '../../components/input/input.component';
import {CommandService} from '../../services/command-service';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable,
  MatTableDataSource
} from '@angular/material/table';
import {Document} from '../../services/models/document.model';
import {DatePipe} from '@angular/common';
import {MatPaginator} from '@angular/material/paginator';
import {MatProgressBar} from '@angular/material/progress-bar';
import {MatSlideToggle} from '@angular/material/slide-toggle';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {MatTooltip} from '@angular/material/tooltip';
import {SharedModule} from '../../components/shared.module';
import {DamService} from '../../services/dam.service';
import {DownloadService} from '../../services/download.service';

@Component({
  selector: 'antm-documents',
  imports: [
    PageTitleComponent,
    SearchFormComponent,
    ReactiveFormsModule,
    DateRangePickerComponent,
    InputComponent,
    DatePipe,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatPaginator,
    MatProgressBar,
    MatRow,
    MatRowDef,
    MatSlideToggle,
    MatSort,
    MatSortHeader,
    MatTable,
    MatTooltip,
    SharedModule
  ],
  templateUrl: './documents.component.html',
  styleUrl: './documents.component.scss',
})
export class DocumentsComponent implements OnInit {

  form: FormGroup;

  dataSource = new MatTableDataSource<Document>();
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  columns: string[] = ['name', 'date', 'type', 'actions'];

  constructor(
    private _fb: FormBuilder,
    private _commandService: CommandService,
    private _damService: DamService,
    private _downloadService: DownloadService
  ) {
    this.form = this._fb.group({
      label: [''],
      startDate: [''],
      endDate: ['']
    })
  }

  ngOnInit(): void {
    this._commandService.getDocuments().subscribe((documents) => {
      console.log('Documents received:', documents);
      this.dataSource.data = documents;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  downloadDocument(id: string, name: string = "fichier-sans-nom.pdf") {
    this._downloadService.download(this._damService.download(id), name);
  }

  search() {

  }

  reset() {

  }
}
